import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { accessibleOnClick } from '../../../../../../../../../shared/utils/accessible-on-click';
import { Trash } from '../../../../../../../../../shared/svg/trash';

const DiscardEmailChangesModal = ({ show, onClose, onHide }) => (
  <Modal
    show={show}
    onHide={onHide}
    onClose={onClose}
    backdrop="static"
    centered
    className="discard-email-changes-modal"
  >
    <div className="discard-email-changes-modal-container">
      <div className="discard-email-changes-modal-header">
        <Trash width={24} height={24} className="trash-icon" />
        <span>Discard Changes</span>
      </div>
      <div className="discard-email-changes-modal-body">
        <div className="discard-email-changes-modal-text">
          Your email is already in draft version. If you continue, this draft
          will be discarded.
        </div>
        <div className="discard-email-changes-modal-text-description">
          Are you sure you want to discard the changes?
        </div>
      </div>
      <div className="divider-line" />
    </div>
    <div className="discard-email-changes-modal-footer">
      <div className="cancel-button" {...accessibleOnClick(onClose)}>
        Cancel
      </div>
      <div className="discard-btn" {...accessibleOnClick(onHide)}>
        <Button>Confirm</Button>
      </div>
    </div>
  </Modal>
);

export default DiscardEmailChangesModal;
